module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.11022/js/img/upgrade-modal/pages-adaptive-test.png"